import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { Grid, GridItem, Heading } from '@chakra-ui/react';
import { AdditionalFacilitiesFormFields } from 'src/@types';
import { validationMessages } from '../../../../shared/validation/validation-messages';
import { isValidDutchPhoneNumber, isValidZipcode } from '../../../../../utils/validations';
import { additionalFacilitiesFormFields } from '../config';
import { FormElementDynamicInputTyped } from '../../../../shared/form-elements';

export const AdditionalFacilitiesEmployerSection = ({
  heading,
  register,
  values,
  errors
}: {
  heading: string;
  register: UseFormRegister<AdditionalFacilitiesFormFields>;
  values: AdditionalFacilitiesFormFields;
  errors: FieldErrors<AdditionalFacilitiesFormFields>;
}) => {
  return (
    <>
      <Heading size={`md`}>{heading}</Heading>
      <Grid
        templateColumns={{
          base: 'repeat(1, 1fr)',
          md: 'repeat(2, 1fr)'
        }}
        gap={4}>
        <GridItem colSpan={{ base: 1, md: 2 }}>
          <FormElementDynamicInputTyped<AdditionalFacilitiesFormFields>
            formFields={additionalFacilitiesFormFields}
            id={'employerName'}
            register={register}
            errors={errors}
            values={values}
            options={{ required: true }}
          />
        </GridItem>

        <FormElementDynamicInputTyped<AdditionalFacilitiesFormFields>
          formFields={additionalFacilitiesFormFields}
          id={'employerAddress'}
          register={register}
          errors={errors}
          values={values}
          options={{ required: true }}
        />

        <FormElementDynamicInputTyped<AdditionalFacilitiesFormFields>
          formFields={additionalFacilitiesFormFields}
          id={'employerPostCode'}
          validation={{
            required: validationMessages.required,
            validate: (value: string) => isValidZipcode(value, validationMessages.zipCode)
          }}
          register={register}
          errors={errors}
          values={values}
        />

        <FormElementDynamicInputTyped<AdditionalFacilitiesFormFields>
          formFields={additionalFacilitiesFormFields}
          id={'employerPlace'}
          register={register}
          errors={errors}
          values={values}
          options={{ required: true }}
        />

        <FormElementDynamicInputTyped<AdditionalFacilitiesFormFields>
          formFields={additionalFacilitiesFormFields}
          id={'contactPerson'}
          register={register}
          errors={errors}
          values={values}
          options={{ required: true }}
        />

        <FormElementDynamicInputTyped<AdditionalFacilitiesFormFields>
          formFields={additionalFacilitiesFormFields}
          id={'contactPersonPhoneNumber'}
          register={register}
          errors={errors}
          values={values}
          validation={{
            required: validationMessages.required,
            validate: (value: string) =>
              isValidDutchPhoneNumber(value, validationMessages.phoneNumber)
          }}
        />
      </Grid>
    </>
  );
};
